const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (email: string): boolean =>
  EMAIL_REGEX.test(email.trim());

export const isValidPhone10Digits = (phone: string): boolean =>
  /^\d{10}$/.test(phone);

export const sanitizePhoneInput = (value: string): string =>
  value.replace(/\D/g, "").slice(0, 10);
